"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { ApplyButton } from "~/components/ui/apply-button-eon";
import { useLanguage } from "~/translations/loader/use-language";
import type { Job } from "~/types/job";
interface ContactEconProps {
  job: Job;
}
export default function ContactEcon(t0) {
  const $ = _c(16);
  const {
    job
  } = t0;
  const t = useLanguage();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="mb-10 font-bold text-4xl xl:text-5xl">Ready? Set, Go!</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = t.econ_contact || "";
  let t3;
  if ($[1] !== t2) {
    t3 = <div className="flex items-center gap-x-4"><div className="space-y-2 md:max-w-xl" dangerouslySetInnerHTML={{
        __html: t2
      }} /></div>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== job) {
    t4 = job.data.applicationUrl && job.data.applicationUrl.length > 2 && <ApplyButton job={job} variant="econ" />;
    $[3] = job;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== job) {
    t5 = job.data.applicationUrlDirect && <ApplyButton direct={true} job={job} variant="econ" />;
    $[5] = job;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div className="mt-10 flex flex-col gap-4 md:flex-row">{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <div className="order-2 px-6 py-10 md:order-first md:px-0 md:py-14">{t1}{t3}{t6}</div>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="relative my-auto xl:h-full"><CustomImage alt="Recruiting Team ECON" className="aspect-square h-full object-cover" height={1200} src="images/recruiter/subclients/econ/default.jpg" width={1800} /></div>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7) {
    t9 = <section className="outer-container overflow-hidden bg-primary text-lg text-white print:hidden" id="contact"><div className="inner-container"><div className="grid gap-x-8 md:auto-cols-fr md:grid-flow-col xl:auto-cols-[2fr_1.5fr]">{t7}{t8}</div></div></section>;
    $[14] = t7;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}